import {brand, Branded, TypeOf} from 'io-ts';
import {NonEmptyString} from './NonEmptyString';

export const DateString = brand(
    NonEmptyString,
    (_): _ is Branded<NonEmptyString, {readonly DateString: unique symbol}> => true,
    'DateString'
);
export type DateString = TypeOf<typeof DateString>;
